import React, { useContext, useReducer, useState } from "react";
import Box from "@mui/material/Box";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { TheContext } from "../Context";
import "../App.css";

export default function CelebrityItemEdit({ celebRead }) {
  const { expandedId, changeExpandedId, setEditCelebId, updateCeleb } =
    useContext(TheContext);
  const [isUpdated, setIsUpdated] = useState(false);

  const genders = ["male", "female", "transgender", "rather not say", "other"];

  const handleCancel = () => setEditCelebId(false);
  const handleSave = () => {
    console.log("Saving celeb:", celeb);
    updateCeleb(celebRead.id, celeb);
    setEditCelebId(false);
  };
  const [celeb, setCeleb] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    celebRead
  );
  const handleInput = (event) => {
    const name = event.target.name;
    const newValue = event.target.value;
    setCeleb({ [name]: newValue });
    setIsUpdated(true);
  };

  const isEmpty = (value) => {
    return value == null || value === "";
  };

  const hasError = () => {
    return (
      isEmpty(celeb.name) ||
      isEmpty(celeb.age) ||
      isEmpty(celeb.gender) ||
      isEmpty(celeb.country) ||
      isEmpty(celeb.description) ||
      /[0-9]/.test(celeb.country)
    );
  };

  return (
    <Accordion
      key={celeb.id}
      expanded={expandedId === celeb.id}
      onChange={changeExpandedId(celeb.id)}
      sx={{ borderRadius: 5, marginTop: 2 }}
    >
      <form onSubmit={handleSave}>
        <FormControl sx={{ display: "flex", justifyContent: "inherit" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <img
              src={celeb.picture}
              alt={celeb.name}
              style={{ borderRadius: 50 }}
            ></img>
            <TextField
              required
              name="name"
              label="Name"
              id="outlined-required"
              defaultValue={celeb.name}
              onChange={handleInput}
              sx={{ marginLeft: 2 }}
            />
          </AccordionSummary>
          <AccordionDetails
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <TextField
                name="age"
                label="Age"
                required
                id="age-input"
                type="number"
                defaultValue={celeb.age}
                onChange={handleInput}
              />
            </div>
            <div>
              <FormControl>
                <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={celeb.gender}
                  label="Gender"
                  name="gender"
                  onChange={handleInput}
                  className="capitalize"
                >
                  {genders.map((gender) => (
                    <MenuItem
                      key={gender}
                      value={gender}
                      className="capitalize"
                    >
                      {gender}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div>
              <TextField
                id="country-input"
                name="country"
                label="Country"
                required
                error={/[0-9]/.test(celeb.country)}
                helperText="Numbers not allowed"
                type="text"
                defaultValue={celeb.country}
                onChange={handleInput}
              />
            </div>
          </AccordionDetails>

          <AccordionDetails>
            <TextField
              id="description-input"
              name="description"
              label="Description"
              required
              type="text"
              defaultValue={celeb.description}
              onChange={handleInput}
              multiline
              maxRows={4}
              style={{ width: "100%" }}
            />
          </AccordionDetails>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              m: 1,
            }}
          >
            <Button
              sx={{ color: "green" }}
              onClick={handleSave}
              disabled={!isUpdated || hasError()}
            >
              <CheckCircleOutlinedIcon />
            </Button>
            <Button sx={{ color: "red" }} onClick={handleCancel}>
              <CancelOutlinedIcon />
            </Button>
          </Box>
        </FormControl>
      </form>
    </Accordion>
  );
}
